export const browsers = [
  {
    name: 'Chrome',
    href: 'https://www.google.com/intl/en/chrome',
  },
  {
    name: 'Mozilla Firefox',
    href: 'https://www.mozilla.org/en-US/firefox/new',
  },
  {
    name: 'Microsoft Edge',
    href: 'https://www.microsoft.com/en-US/edge',
  },
]
